'use client'
import { useEffect } from 'react'

declare global {
  interface Window {
    Intercom?: (...args: any[]) => void
    intercomSettings?: {
      app_id: string
      name?: string
      email?: string
      user_id?: string
    }
  }
}

const APP_ID = process.env.NEXT_PUBLIC_INTERCOM_APP_ID
if (!APP_ID) {
  throw new Error('Intercom APP_ID não foi definido!')
}

const IntercomProvider = () => {
  useEffect(() => {
    const loadIntercom = () => {
      if (typeof window !== 'undefined') {
        window.intercomSettings = {
          app_id: APP_ID,
        }

        // Carregar o Intercom de forma assíncrona
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.async = true
        script.src = `https://widget.intercom.io/widget/${APP_ID}`

        // Adiciona o script no head da página
        script.onload = () => {
          if (typeof window.Intercom === 'function') {
            window.Intercom('reattach_activator')
            window.Intercom('update', window.intercomSettings)
          }
        }

        const firstScriptTag = document.getElementsByTagName('script')[0]
        firstScriptTag.parentNode?.insertBefore(script, firstScriptTag)
      }
    }

    // Carregar o Intercom após a página ter carregado
    if (typeof window !== 'undefined') {
      window.onload = loadIntercom
    }

    // Limpar o evento para não sobrescrever
    return () => {
      if (typeof window !== 'undefined' && window.onload === loadIntercom) {
        window.onload = null
      }
    }
  }, [])

  return null
}

export default IntercomProvider
